@if (store.services()?.length) {
    <form [formGroup]="form()">
        <p-cascadeSelect
            appendTo="body"
            dataKey="id"
            [formControlName]="id()"
            [options]="$any(store.services())"
            [invalid]="isInvalid()"
            optionLabel="value"
            optionGroupLabel="name"
            [class]="'w-full' + (required() ? ' required-input-border' : '')"
            [optionGroupChildren]="['contracts']"
            [placeholder]="'user.createUser.jobInService' | translate"
            (onChange)="contractSelected.emit($event)"
        >
            <ng-template #option let-option>
                <span>{{ option?.name || 'user.createUser.contracts.' + option?.value | translate }}</span>
            </ng-template>

            <ng-template #value let-value>
                @if (value) {
                    <span>
                        {{ value?.parentName }}: {{ 'user.createUser.contracts.' + $safeNavigationMigration(value?.value) | translate }}
                    </span>
                } @else {
                    {{ 'user.createUser.jobInService' | translate }}
                }
            </ng-template>
        </p-cascadeSelect>
    </form>
    <app-field-error [form]="form()" [id]="id()"></app-field-error>
}
